import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center bg-gray-200 px-4 py-8 sm:py-12" }
const _hoisted_2 = { class: "w-full max-w-md" }
const _hoisted_3 = { class: "text-center mb-6 sm:mb-8" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 text-base sm:text-lg font-medium" }, " Redefinição de senha ", -1)
const _hoisted_6 = { class: "bg-white rounded-xl sm:rounded-2xl shadow-lg p-6 sm:p-8 border border-gray-200" }
const _hoisted_7 = {
  key: 0,
  class: "text-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 mb-4" }, " Link inválido. Solicite a redefinição de senha novamente na tela de login. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600 px-3" }, " Crie a sua nova senha de acesso ao Portal de Agendamentos. ", -1)
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = { class: "pt-2 md:px-2" }
const _hoisted_14 = {
  key: 0,
  class: "flex items-center justify-center gap-2"
}
const _hoisted_15 = {
  key: 1,
  class: "flex items-center justify-center gap-2"
}
const _hoisted_16 = { class: "text-center text-sm" }
const _hoisted_17 = { class: "text-center text-xs text-gray-400 mt-6" }

import { ref, computed } from "vue";
import { branding, getThemeColor } from "@/branding";
import router from "@/router";
import store from "@/store";
import helpers from "@/helpers";
import { useRoute } from "vue-router";
import InputText from "@/components/inputs/InputText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RedefinirSenha',
  setup(__props) {

const theme = getThemeColor();
const logoUrl = `${process.env.BASE_URL}img/moinho-globo-logo.png`;

const route = useRoute();
const token = computed(() => String(route.query.token ?? ""));

const password = ref("");
const passwordConfirmation = ref("");
const senhaVisivel = ref(false);
const salvando = ref(false);

const salvar = async (e: Event) => {
  e.preventDefault();

  if (!password.value || password.value.length < 6) {
    helpers.mensagemErro("A senha deve ter pelo menos 6 caracteres.");
    return;
  }

  if (password.value !== passwordConfirmation.value) {
    helpers.mensagemErro("A confirmação de senha não confere.");
    return;
  }

  salvando.value = true;
  try {
    const retorno = await store.dispatch("redefinirSenha", {
      token: token.value,
      password: password.value,
      password_confirmation: passwordConfirmation.value,
    });

    if (retorno?.success) {
      helpers.mensagemSucesso(retorno.mensagem ?? "Senha alterada com sucesso!");
      router.push("/login");
    }
  } finally {
    salvando.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: logoUrl,
          alt: _unref(branding).brandName,
          class: "mx-auto h-16 sm:h-20 w-auto mb-4"
        }, null, 8, _hoisted_4),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_unref(token))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, {
                icon: "exclamation-triangle",
                class: "text-3xl text-orange-500 mb-3"
              }),
              _hoisted_8,
              _createVNode(_component_router_link, {
                to: { name: 'Login' },
                class: _normalizeClass(["font-semibold underline", `text-${_unref(theme)}-800`])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Voltar para o login ")
                ]),
                _: 1
              }, 8, ["class"])
            ]))
          : (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: salvar,
              class: "space-y-5"
            }, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(InputText, {
                  name: "password",
                  label: "Nova senha",
                  type: senhaVisivel.value ? 'text' : 'password',
                  tclass: "w-full",
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                  placeholder: "Mínimo de 6 caracteres"
                }, null, 8, ["type", "modelValue"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "absolute right-6 top-11 text-gray-400 hover:text-gray-600 transition-colors duration-200 focus:outline-none z-10 cursor-pointer",
                  "aria-label": senhaVisivel.value ? 'Ocultar senha' : 'Mostrar senha',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (senhaVisivel.value = !senhaVisivel.value))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: senhaVisivel.value ? 'eye' : 'eye-slash',
                    class: "text-lg"
                  }, null, 8, ["icon"])
                ], 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(InputText, {
                  name: "password_confirmation",
                  label: "Confirmar nova senha",
                  type: senhaVisivel.value ? 'text' : 'password',
                  tclass: "w-full",
                  modelValue: passwordConfirmation.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordConfirmation).value = $event)),
                  placeholder: "Repita a nova senha"
                }, null, 8, ["type", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_t_button, {
                  type: "submit",
                  disabled: salvando.value,
                  class: _normalizeClass(["w-full py-3 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-4 disabled:opacity-70 disabled:cursor-not-allowed", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900 focus:ring-${_unref(theme)}-300`])
                }, {
                  default: _withCtx(() => [
                    (salvando.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "sync-alt",
                            spin: ""
                          }),
                          _createTextVNode(" Salvando... ")
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                          _createVNode(_component_font_awesome_icon, { icon: "check" }),
                          _createTextVNode(" Salvar nova senha ")
                        ]))
                  ]),
                  _: 1
                }, 8, ["disabled", "class"])
              ]),
              _createElementVNode("p", _hoisted_16, [
                _createVNode(_component_router_link, {
                  to: { name: 'Login' },
                  class: "text-gray-500 underline hover:text-gray-700 transition-colors duration-150"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Voltar para o login ")
                  ]),
                  _: 1
                })
              ])
            ], 32))
      ]),
      _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(branding).pageTitle), 1)
    ])
  ]))
}
}

})